import { entitlementsSelectors } from 'app-components/flux/entitlements';
import { getNavFromKey, navOrderV2 } from 'containers/App/paths';
import { useAppSelector } from 'hooks/redux';
import React, { useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import { GroupNavItem, MainNavItem } from '../NavItems';

const useStyles = makeStyles()(() => ({
  navPopover: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
}));

export const NavPopoverV2 = React.memo(function NavPopoverV2() {
  const { classes } = useStyles();
  const businessEnabled = useAppSelector(entitlementsSelectors.getBusinessEnabled);

  const renderNavKey = useCallback(
    (navKey: string | readonly string[], idx: number) => {
      if (typeof navKey !== 'string') {
        if (navKey[0] === 'Business' && !businessEnabled) return null;
        return <GroupNavItem key={`group-${navKey[0]}-${idx}`} />;
      }
      const nav = getNavFromKey(navKey);
      if (nav) return <MainNavItem key={`nav-item-${nav.path}`} nav={nav} section='main' />;
      return null;
    },
    [businessEnabled],
  );

  return <div className={classes.navPopover}>{navOrderV2.map(renderNavKey)}</div>;
});
